export default "__VITE_ASSET__Beiih4QZ__";